export default function LotteryNumlotWinningNumbers({ mainNumber, bonusNumber, config, size = "md", fontSize }) {
  if (!mainNumber) return null;

  const isNumbers = config?.type === "numbers";
  const isBingo = config?.type === "bingo";
  const mainNumbers = mainNumber ? mainNumber.split(",") : [];
  const bonusNumbers = bonusNumber ? bonusNumber.split(",") : [];

  const ballSize = {
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  }[size];
const bingoBallSize = {
  sm: "w-20 h-8",
  md: "w-24 h-10",
  lg: "w-28 h-12",
  xl: "w-32 h-14",
}[size];

  // ビンゴ5：3×3グリッド
  // 1 2 3
  // 4 FREE 5
  // 6 7 8
  const bingoGrid = [
    mainNumbers[0], mainNumbers[1], mainNumbers[2],
    mainNumbers[3], "FREE",         mainNumbers[4],
    mainNumbers[5], mainNumbers[6], mainNumbers[7],
  ];
  if (isBingo) {
    return (
      <div className="grid grid-cols-3 gap-[2px] w-fit mx-auto">
        {bingoGrid.map((num, i) => (
          <span
            key={i}
            className={`${isBingo ? bingoBallSize : ballSize} font-['Gravitas_One'] select-none flex items-center justify-center rounded-t-lg rounded-b-sm ${fontSize || ""} ${
              num === "FREE"
                ? "bg-gray-800 text-base-50 text-[12px]"
                : "bg-primary-500 text-base-50"
            }`}
          >
            {num}
          </span>
        ))}
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center gap-1 flex-wrap">
      {isNumbers ? (
        <div className="flex gap-1">
          {mainNumber.split("").map((num, i) => (
            <span
              key={i}
              className={`${ballSize} font-['Gravitas_One'] select-none flex items-center justify-center bg-primary-500 text-base-50 rounded-full ${fontSize || ""}`}
            >
              {num}
            </span>
          ))}
        </div>
      ) : (
        <>
          {mainNumbers.map((num, i) => (
            <span
              key={`main-${i}`}
              className={`${ballSize} font-['Gravitas_One'] select-none flex items-center justify-center bg-primary-500 text-base-50 rounded-full ${fontSize || ""}`}
            >
              {num}
            </span>
          ))}
          {bonusNumbers.map((num, i) => (
            <span
              key={`bonus-${i}`}
              className={`${ballSize} font-['Gravitas_One'] select-none flex items-center justify-center bg-gray-800 text-base-50 rounded-full ml-1 ${fontSize || ""}`}
            >
              {num}
            </span>
          ))}
        </>
      )}
    </div>
  );
}